// src/components/profile/StatusBadge.jsx

import React from 'react';
import { Box } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import StarIcon from '@material-ui/icons/Star';
import { COLORS, useProfileStyles } from './profileStyles';

const variantMap = {
  success: {
    bg: COLORS.successBg,
    color: COLORS.success,
    icon: CheckCircleIcon,
  },
  dark: {
    bg: 'rgba(0,0,0,0.35)',
    color: '#fff',
    icon: StarIcon,
  },
};

const StatusBadge = ({
  label,
  variant = 'success',
}) => {
  const classes = useProfileStyles();

  const selectedVariant = variantMap[variant] || variantMap.success;
  const Icon = selectedVariant.icon;

  return (
    <Box
      className={classes.statusBadge}
      style={{
        background: selectedVariant.bg,
        color: selectedVariant.color,
      }}
    >
      <Icon
        style={{
          fontSize: 18,
          marginRight: 8,
        }}
      />

      {label}
    </Box>
  );
};

export default StatusBadge;